// @flow

import React from 'react';
import styled from 'styled-components';

import { flex, Width } from 'styles';
import Social from './Social';
import Apps from './Apps';
import { usePageState } from 'contexts';

const Wrapper = styled.div`
  margin-top: 40px;
  order: 1;

  @media print, screen and (min-width: ${Width.BREAK_SM}px) {
    margin-top: 0;
    order: unset;
  }

  > div {
    &:nth-of-type(1) {
      margin-bottom: 24px;
      order: 1;
    }
    &:nth-of-type(2) {
      order: 2;
    }
  }
  @media print, screen and (min-width: ${Width.BREAK_SM}px) {
    ${flex('space-between', 'center')};

    > div {
      &:nth-of-type(1) {
        order: unset;
        margin-bottom: 0;
      }
      &:nth-of-type(2) {
        order: unset;
      }
    }
  }
`;

const Icons = () => {
  const {
    footerConfig: { toggleHidden },
  } = usePageState();
  return !toggleHidden?.icons ? (
    <Wrapper>
      <Social />
      <Apps />
    </Wrapper>
  ) : null;
};

export default Icons;
